import styled, { css } from 'styled-components'
import { flexbox, maxWidth, space, zIndex } from 'styled-system'

import { motion } from 'framer-motion'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

type ContainerProps = {
  wideContent?: boolean
  column?: boolean
}

const wideContentCss = ({ wideContent }: ContainerProps) =>
  wideContent &&
  css`
    max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  `

const motionCustomColumnCss = ({ column }: ContainerProps) =>
  column &&
  css`
    flex-direction: column;
  `

export const Container = styled(motion.div)<ContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  position: relative;

  ${flexbox};
  ${zIndex};
  ${maxWidth};
  ${space};

  ${motionCustomColumnCss}
  ${wideContentCss};
`
